module.exports = __webpack_public_path__ + "img/news5.b0663e51.png";